import styled from "styled-components";
import Color from "../../constants/Color";
import { SpacingType } from "../../constants/Spacing";
import Breakpoint from "../../constants/Breakpoint";

interface Props {
    margin?: SpacingType;
    marginTop?: SpacingType;
    marginBottom?: SpacingType;
    marginLeft?: SpacingType;
    marginRight?: SpacingType;
}

const Title = styled.h1<Props>`
    padding: 0px;
    font-weight: 700;
    font-size: 34px;
    line-height: 42px;
    color: ${Color.TEXT_DARK_1};

    @media (${Breakpoint.PHONE_AND_DOWN}) {
        font-size: 30px;
        line-height: 30px;
    }

    margin: ${({ margin }: Props) => margin || 0};
    margin-top: ${({ marginTop }: Props) => marginTop || 0};
    margin-bottom: ${({ marginBottom }: Props) => marginBottom || 0};
    margin-left: ${({ marginLeft }: Props) => marginLeft || 0};
    margin-right: ${({ marginRight }: Props) => marginRight || 0};
`;

export default Title;
